// extracted by mini-css-extract-plugin
export default {"wrapper":"OverallAppOverlay_wrapper__hr8Pu"};